<div class="password-reset-container" *ngIf="!isLoadingLabels">
	<div class="password-input-container">
		<span class="title">{{ labels.lbl_tools_complexidade_senha }}</span>
		<div class="security-meter-container">
			<span
				class="pl-1"
				[ngStyle]="{
					width: securityMeterPercentage + '%',
					'background-color': 'var(--' + securityMeterColor + ')',
					color: 'var(--const-white)',
				}"
				>{{ securityMeterText }}</span
			>
		</div>
	</div>

	<div class="password-input-container">
		<ng-container *ngIf="isLoggedIn">
			<span class="title">{{ labels.lbl_geral_senha_atual }}</span>
			<div class="input-bubble">
				<input type="{{ oldPasswordViewType }}" [value]="oldPassword" (input)="oldPassword = $event.target.value" />
				<span
					class="showPassword"
					(click)="oldPasswordViewType === 'text' ? (oldPasswordViewType = 'password') : (oldPasswordViewType = 'text')"
					><fa-icon [icon]="oldPasswordViewType === 'text' ? faEye : faEyeSlash"></fa-icon
				></span>
			</div>
		</ng-container>

		<span class="title">{{ labels.lbl_geral_senha_nova }}</span>
		<div class="input-bubble">
			<input
				type="{{ newPasswordViewType }}"
				[value]="newPassword"
				(input)="newPassword = $event.target.value; calculateNewPasswordStrength(); confirmEqualNewPassword()" />
			<span
				class="showPassword"
				(click)="newPasswordViewType === 'text' ? (newPasswordViewType = 'password') : (newPasswordViewType = 'text')"
				><fa-icon [icon]="newPasswordViewType === 'text' ? faEye : faEyeSlash"></fa-icon
			></span>
		</div>

		<span class="title">{{ labels.lbl_confirma_senha }}</span>
		<div class="input-bubble">
			<input
				type="{{ confirmNewPasswordViewtype }}"
				[value]="confirmNewPassword"
				(input)="confirmNewPassword = $event.target.value; confirmEqualNewPassword()" />
			<span
				class="showPassword"
				(click)="
					confirmNewPasswordViewtype === 'text'
						? (confirmNewPasswordViewtype = 'password')
						: (confirmNewPasswordViewtype = 'text')
				"
				><fa-icon [icon]="confirmNewPasswordViewtype === 'text' ? faEye : faEyeSlash"></fa-icon
			></span>
		</div>
	</div>

	<div class="button-container mt-4">
		<div
			*ngIf="isLoggedIn"
			class="button"
			[ngClass]="{
				disabled: !oldPassword || !newPassword || !confirmNewPassword || !canSubmitNewPassword || !isConfirmEqualNewPassword,
			}"
			(click)="submitNewPassword()">
			{{ labels.lbl_update_password }}
			<cpi-dot-bounce-loading-effect [color]="'var(--white)'" *ngIf="isUpdatingPassword"></cpi-dot-bounce-loading-effect>
		</div>
		<div
			*ngIf="!isLoggedIn"
			class="button"
			[ngClass]="{
				disabled: emailNullorEmpty || !newPassword || !confirmNewPassword || !canSubmitNewPassword || !isConfirmEqualNewPassword,
			}"
			(click)="recoverPassword()">
			{{ labels.lbl_update_password }}
			<cpi-dot-bounce-loading-effect [color]="'var(--white)'" *ngIf="isUpdatingPassword"></cpi-dot-bounce-loading-effect>
		</div>
	</div>

	<div class="alert-container mt-2">{{ alertMessage }}</div>
</div>
